module.exports = __webpack_public_path__ + "static/media/PLANIFICACION_TERRITORIAL_8.6a818e17.png";